import {

    UPDATE_PLEDGE_INSURANCE_DATA,
    UPDATE_WASIYAT_DATA,
    RESET_PLEDGE_DATA,
    UPDATE_CPF_DATA,
    UPDATE_SELECTED_PLEDGE,
    UPDATE_DOCUMENTS,
    REMOVE_DOCUMENT,
    UPDATE_CATEGORY_PLEDGE
} from '../constants';

const pledgeDefaultState = () => ({
    wasiat: {
        id: 1, amount: 0.00,
        documents: [],
        isEligible: true,
        Gold: false,
        assetValue: null,
        wmspercentage: null,
        iAgree: false,
        pledgeValue: null,
        "Bank Savings": false,
        "Share of Property/Properties": false,
        "Investments/Shares": false
    },
    cpf: {
        id: 2,
        documents: [],
        isEligible: true,
        cpfSaving: null,
        nominationShare: null,
        pledgeValue: null,
        iAgree: false,
    },
    insurance: { id: 3, amount: 0.00, documents: [], isEligible: true, isSelected: false, companyName: '', policyName: '', type: 'Not Provided', estimatePolicyValue: 0, shareOfNomination: 0, pledgeValue: 0, iAgree: false },
    isSubmitting: false,
    nisabValue: 0,
    selectedPledgeId: null,
    category: null
});


export default function pledgeReducer(state = pledgeDefaultState(), action) {

    switch (action.type) {

        //   wasiat

        case UPDATE_WASIYAT_DATA: {
            return { ...state, ...{ wasiat: action.wasiat } };
        }

        case UPDATE_CPF_DATA: {
            return { ...state, ...{ cpf: action.cpf } };
        }

        case UPDATE_PLEDGE_INSURANCE_DATA: {
            return { ...state, ...{ insurance: action.insurance } };
        }

        case UPDATE_SELECTED_PLEDGE: {
            return { ...state, selectedPledgeId: action.id }
        }

        case UPDATE_CATEGORY_PLEDGE: {
            return { ...state, category: action.category }
        }
        // case RESET_GOLD_DATA:
        //     return { ...state , ...{ gold: pledgeDefaultState().gold } };

        case UPDATE_DOCUMENTS: {
            const { category, documents } = action.payload;
            return {
                ...state,
                [category]: {
                    ...state[category],
                    documents: [...state[category].documents, ...documents]
                }
            };
        }

        case REMOVE_DOCUMENT: {
            const { category, documentToRemove } = action.payload;
            const updatedDocuments = state[category].documents.filter(doc => doc.name !== documentToRemove.name);
            return {
                ...state,
                [category]: {
                    ...state[category],
                    documents: updatedDocuments
                }
            };
        }
        
        case RESET_PLEDGE_DATA:
            return pledgeDefaultState();

        default:
            return state;
    }

}